import styled from 'styled-components';

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.danger};
  height: 32px;
  width: 32px;

  & > svg {
    object-fit: contain;
  }
`;

export const Description = styled.p`
  all: unset;
  margin: 1px 0;
`;
